<template>
  <BreadCrumb PageTitle="File Manager" />
  <RecentFiles />
  <DocumentsFiles />
  <AssetsFiles />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../template-components/Common/BreadCrumb.vue";
import RecentFiles from "../template-components/FileManager/RecentFiles.vue";
import DocumentsFiles from "../template-components/FileManager/DocumentsFiles.vue";
import AssetsFiles from "../template-components/FileManager/AssetsFiles.vue";

export default defineComponent({
  name: "FileManagerPage",
  components: {
    BreadCrumb,
    RecentFiles,
    DocumentsFiles,
    AssetsFiles,
  },
});
</script>